export default "__VITE_ASSET__zIKN6dfI__"